import React from 'react';
import { ErrorMessage } from './error-message';
import classNames from 'classnames';
export const Input = React.forwardRef(({ error, ...props }, ref) => {
    const css = classNames({
        'form-field__input': true,
        'form-control--error': !!error
    });
    return (<>
      <input className={css} ref={ref} {...props}/>
      <ErrorMessage error={error}></ErrorMessage>
    </>);
});
